import React from 'react';
import { render } from 'react-dom';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './components/App';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Notification from './components/Notification';
import Owner from './components/Owner';
import Child from './components/Child';
import Admin from './components/Admin';
import User from './components/User';
import Operation from './components/Operation';
import Logout from './components/Logout';
import OwnerModify from './components/OwnerModify';
import OwnerInfo from './components/OwnerInfo';
import ChildModify from './components/ChildModify';
import ChildInfo from './components/ChildInfo';
import AdminInfo from './components/AdminInfo';
import UserInfo from './components/UserInfo';
import Payment from './components/Payment';
import SignupConfirm from './components/SignupConfirm';
import AdminAdd from './components/AdminAdd';
import UserAdd from './components/UserAdd';
import Register from './components/Register';

const root = document.getElementById('root');

render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />}>
        <Route path="dashboard" element={<Dashboard />} />
        <Route
          path="notification"
          element={<Notification />}
        />
        <Route path="owner">
          <Route index element={<Owner />} />
          <Route path="modify" element={<OwnerModify />}>
            <Route path=":id" element={<OwnerModify />} />
          </Route>
          <Route path=":id" element={<OwnerInfo />} />
        </Route>
        <Route path="child">
          <Route index element={<Child />} />
          <Route path="modify" element={<ChildModify />}>
            <Route path=":id" element={<ChildModify />} />
          </Route>
          <Route path=":id" element={<ChildInfo />} />
        </Route>
        <Route path="admin">
          <Route index element={<Admin />} />
          <Route path="add" element={<AdminAdd />} />
          <Route path=":id" element={<AdminInfo />} />
        </Route>
        <Route path="user">
          <Route index element={<User />} />
          <Route path="add" element={<UserAdd />} />
          <Route path=":id" element={<UserInfo />} />
        </Route>
        <Route
          path="operation"
          element={<Operation />}
        />
        <Route path="logout" element={<Logout />} />
        <Route path="payment" element={<Payment />} />
      </Route>
      <Route path="/login" element={<Login />} />
      <Route path="/signup">
        <Route path=":email/:code" element={<SignupConfirm />} />
      </Route>
      <Route path="/register" element={<Register />} />
    </Routes>
  </BrowserRouter>,
  root
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
